import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../firebase";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function ForgotPassword() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle | loading | success | error
  const [errorMsg, setErrorMsg] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    setErrorMsg("");

    try {
      await sendPasswordResetEmail(auth, email.trim());
      setStatus("success");
    } catch (err) {
      const code = err?.code || "";
      if (code === "auth/user-not-found") {
        setErrorMsg(t("forgotPassword.errors.notFound"));
      } else {
        setErrorMsg(t("forgotPassword.errors.generic"));
      }
      setStatus("error");
    }
  };

  return (
    <main className="min-h-screen bg-[#272c39] text-white">
      <div className="mx-auto max-w-3xl px-4 pt-10 pb-24">
        <div className="h-12" />

        <section className="mx-auto max-w-md">
          <h1 className="text-center font-unbounded text-3xl font-extrabold tracking-tight">
            {t("forgotPassword.title")}
          </h1>
          <p className="mt-2 text-center text-white/70">
            {t("forgotPassword.subtitle")}
          </p>

          {status === "success" ? (
            <div className="mt-10 rounded-2xl border border-[#98dea3]/30 bg-[#98dea3]/10 px-6 py-8 text-center">
              <div className="mb-3 text-3xl">📬</div>
              <p className="text-white/90">
                {t("forgotPassword.success", { email })}
              </p>
              <Link
                to="/login"
                className="mt-6 inline-block font-medium text-[#98dea3] hover:underline"
              >
                {t("forgotPassword.backToLogin")}
              </Link>
            </div>
          ) : (
            <form onSubmit={submit} className="mt-8 space-y-5">
              <div>
                <label htmlFor="email" className="mb-2 block text-sm text-white/90">
                  {t("forgotPassword.field")}
                </label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder={t("forgotPassword.placeholder")}
                  className="w-full rounded-xl border border-white/10 bg-[#7269e3] px-4 py-3 text-white placeholder-white/80 outline-none focus:ring-2 focus:ring-[#a783a6]"
                  required
                  disabled={status === "loading"}
                />
              </div>

              {status === "error" && (
                <p className="rounded-xl border border-red-400/30 bg-red-400/10 px-4 py-3 text-sm text-red-300">
                  {errorMsg}
                </p>
              )}

              <div className="pt-2">
                <button
                  type="submit"
                  disabled={status === "loading"}
                  className="w-full rounded-xl bg-[#7269e3] px-5 py-3 text-lg font-semibold text-white shadow-[0_6px_20px_rgba(114,105,227,0.35)] hover:brightness-110 focus:outline-none focus:ring-2 focus:ring-[#a783a6] disabled:opacity-60"
                >
                  {status === "loading" ? "…" : t("forgotPassword.submit")}
                </button>
              </div>

              <p className="text-center text-white/80">
                <Link to="/login" className="font-medium text-[#98dea3] hover:underline">
                  {t("forgotPassword.backToLogin")}
                </Link>
              </p>
            </form>
          )}
        </section>
      </div>
    </main>
  );
}
